import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';

import ViewWrapper from 'views/ViewWrapper';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(0.5),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
});

/*
  Ideas for internal tools
    Create Release QC / approvals
    Venice payment QC / audits
    Data investigations on proof of concept work like Spotify Bulk API
    Invite partner(s) to the Venice platform
    *any operation currently provided by Postman*
    edit partner fees by release
    see royalties earned by partner
    see fees earned by Venice
    distribution performance dashboard (e.g. how Venice is stacking up to Spotify gold tier requirements)
    trigger distributions
    trigger report ingestions
    Pre-Order / Pre-Add based on DSP specifics
    Add FX rates for reports
    Verify statements ↔ reports balances prior to issuing payments
    Total # of Users, Accounts Signed, Revenue, # Releases, # Tracks / Videos, # Streams total
    Measure Company OKRs, SLAs
*/

const Landing = ({ ...props }) => {
  const { classes } = props;

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Venice Internal Web Suite
          </MuiTypography>
          <div>⟵ Use the sidebar on the left to navigate</div>
        </MuiPaper>
      </MuiGrid>
      <MuiGrid item xs={12}>
        <br />
        <br />
        <br />
      </MuiGrid>
    </ViewWrapper>
  );
};

Landing.defaultProps = {};

export default withStyles(styles)(Landing);
